<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      border-variant="secondary"
      class="text-center mt-4"
    >
      <div class="col-sm-12">
        <h1 class="h1cimke">Készletlista</h1>
        <div class="row">

          <div v-if="userType=='admin' || userType=='user'" class="col-sm-4">
            <!-- // NEW -->
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="$router.push({ name: 'CikkekNew' })"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Új cikk hozzáadása
            </b-button>
          </div>

          <!-- // SEARCH INPUT -->
          <div>
            <b-button-group>
              <b-button
                size="sm"
                class="btn float-left"
                variant="outline-danger"
                @click="searchText='', filterSelect='', loadList()"
                ><b-icon-x-circle></b-icon-x-circle>
              </b-button>
            </b-button-group>
          </div>

          <div class="col-sm-2">
            <b-form-input
              size="sm"
              class="form-control"
              ref="searchInput"
              v-model="searchText"
              placeholder="Írj ide valamit!"
              id="search"
              @click="searchText=''"
              @keyup.enter="search()"
              autofocus
            ></b-form-input>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-left"
              variant="success"
              @click="search()"
              ><b-icon-search></b-icon-search>
              Keresés
            </b-button>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-right showbtn"
              variant="outline-primary"
              @click="showNetto()"
              ><b-icon-eye></b-icon-eye>
            </b-button>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-right showbtn"
              variant="outline-primary"
              @click="getListAll()"
              >
              Teljes készletlista
            </b-button>
          </div>

          <div v-if="fullPriceBalance" style="margin-left: 20px">
            <p>
              Össz. készletérték: {{osszKeszletErtekReady}}
            </p>
          </div>

        </div>

      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="list" :fields="fields" :key="list.id">

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button v-if="row.item.closed != 1"
              size="sm"
              @click="
                $router.push({
                  name: 'CikkekNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // NETTÓ BESZÁR -->
          <template v-slot:cell(nettobeszar)="row">
            <p v-show="beszArShow=='1'">{{row.item.nettobeszar}}</p>
          </template>

          <!-- // DELETE -->
          <template v-slot:cell(del)="row">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-modal id="spinner-modal" size="xl" title="" hide-footer hide-header no-close-on-backdrop>
        <div class="text-center">
            Adatok betöltése folyamatban...
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      list: [],
      fields: [
        // {
        //   key: 'id',
        //   label: 'Id',
        //   sortable: true
        //   // sortDirection: 'asc'
        // },
        // {
        //   key: 'emaillink',
        //   label: 'CRM',
        //   sortable: true,
        //   sortDirection: 'desc',
        //   tdClass: 'text-right',
        //   thClass: 'text-right'
        // },
        {
          key: 'nev',
          label: 'Megnevezés',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'csikkCsoport',
          label: 'Cikkcsoport',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'cikkszam',
          label: 'Cikkszám',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'vonalkod',
          label: 'Vonalkód',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'gyarto',
          label: 'Gyártó',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'mennyisegiegyseg',
          label: 'egys.',
          sortable: true,
          thClass: 'text-left'
        },
        {
          key: 'nettobeszar',
          label: 'Nettó besz.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'bruttofogyar',
          label: 'Bruttó fogy.ár',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'mennyiseg',
          label: 'DB',
          sortable: true
          // thClass: 'text-left'
        },
        {
          key: 'keszletertek',
          label: 'Készlet érték',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'bizszam',
          label: 'Biz.szám',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'beszallito',
          label: 'Száll',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'beszerdatum',
          formatter: (value, key, item) => {
            return moment(String(value)).format('YYYY-MM-DD')
          },
          label: 'Beszerzés dátuma',
          sortable: true,
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        { key: 'edit', sortable: false }
        // { key: 'del', sortable: false }
      ],
      myTempAnyagTipus: [],
      searchText: '',
      filterSelect: '',
      beszArShow: 0,
      osszKeszletErtek: 1000000,
      osszKeszletErtekReady: '',
      fullPriceBalance: false
    }
  },
  methods: {
    formatNumber (num) {
      return Number(num).toLocaleString()
    },
    getListAll () {
      console.log('HI')
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        this.$bvModal.show('spinner-modal')
        axios.post('http://' + process.env.ROOT_API + '/keszlet/getlistall', {payload})
          .then(res => {
            this.list = []
            console.log(res.data)
            if (this.beszArShow === 0) {
              this.beszArShow = 1
            } else {
              this.beszArShow = 0
            }

            for (var el in res.data) {
              this.list.push({
                id: res.data[el].cikkid,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].cikkcsoport,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyarto,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: this.formatNumber(res.data[el].nettobeszar),
                bruttofogyar: this.formatNumber(res.data[el].bruttofogyar),
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: this.formatNumber(res.data[el].bruttofogyar * res.data[el].mennyiseg),
                bizszam: res.data[el].bizszam,
                beszallito: res.data[el].beszallito,
                beszerdatum: res.data[el].beszerdatum
              })
              this.osszKeszletErtek = this.osszKeszletErtek + (res.data[el].bruttofogyar * res.data[el].mennyiseg)
              this.osszKeszletErtekReady = this.formatNumber(this.osszKeszletErtek)
            }
            this.$bvModal.hide('spinner-modal')
            this.fullPriceBalance = true
          })
          .catch(err => {
            console.log(err)
          })
      }      
    },
    showNetto () {
      console.log('HI')
      if (this.beszArShow === 0) {
        this.beszArShow = 1
      } else {
        this.beszArShow = 0
      }
    },
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.filterSelect
        payload.searchText = this.searchText
        axios.post(process.env.ROOT_API + '/cikkek/search', {payload})
          .then(res => {
            this.list = []
            for (var el in res.data) {
              this.list.push({
                id: res.data[el].cikkid,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].cikkcsoport,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyarto,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: this.formatNumber(res.data[el].nettobeszar),
                bruttofogyar: this.formatNumber(res.data[el].bruttofogyar),
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: this.formatNumber(res.data[el].bruttofogyar * res.data[el].mennyiseg),
                bizszam: res.data[el].bizszam,
                beszallito: res.data[el].beszallito,
                beszerdatum: res.data[el].beszerdatum              })
            }
            console.log(this.list)
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
        this.fullPriceBalance = false
      }
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    printPDF (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post(process.env.ROOT_API + '/cikkek/pdf', {payload})
          .then(res => {
            this.myTempAnyagTipus = res.data.client
            if (this.myTempAnyagTipus.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.$refs.html2Pdf.generatePdf()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post(process.env.ROOT_API + '/cikkek/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (id, partner) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(ID:' + id + ') ' + partner, {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + '/cikkek/getlist', {payload})
          .then(res => {
            for (var el in res.data) {
              this.list.push({
                id: res.data[el].cikkid,
                nev: res.data[el].nev,
                csikkCsoport: res.data[el].cikkcsoport,
                cikkszam: res.data[el].cikkszam,
                vonalkod: res.data[el].vonalkod,
                gyarto: res.data[el].gyarto,
                mennyisegiegyseg: res.data[el].mennyisegiegyseg,
                nettobeszar: this.formatNumber(res.data[el].nettobeszar),
                bruttofogyar: this.formatNumber(res.data[el].bruttofogyar),
                mennyiseg: res.data[el].mennyiseg,
                keszletertek: this.formatNumber(res.data[el].bruttofogyar * res.data[el].mennyiseg),
                bizszam: res.data[el].bizszam,
                beszallito: res.data[el].beszallito,
                beszerdatum: res.data[el].beszerdatum              })
            }
          })
          .catch(err => {
            console.log(err)
          })
        this.fullPriceBalance = false
      }
    }
  },
  mounted: function () {
    this.loadList()
    this.fullPriceBalance = false
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cikkek.vue